import styled from 'styled-components'

const AddCompanyStyles = styled.div`
	.submitContainer {
		display: flex;
	}
`

export default AddCompanyStyles
